import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=55398273&scoped=true&"
import script from "./Branding.vue?vue&type=script&lang=ts&"
export * from "./Branding.vue?vue&type=script&lang=ts&"
import style0 from "./Branding.vue?vue&type=style&index=0&id=55398273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55398273",
  null
  
)

export default component.exports